import React from "react";

import svg from "../../assets/images/icons/end.svg";

export const EndIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "End"}
    />
);
